import { useMemo } from 'react';
import { UserData } from '@/types/user';

export type ReportButtonState = 'active' | 'pending' | 'disabled';

export function useReportButtonState(userData: UserData | null): ReportButtonState {
  return useMemo(() => {
    if (!userData) return 'disabled';

    // If report is available, show active state regardless of other conditions
    if (userData.reportAvailable) {
      return 'active';
    }

    // Check if all prerequisites are met
    const prerequisitesMet = userData.evaluatorsFinalized && 
                           userData.selfAssessmentCompleted;

    // If prerequisites are met but report isn't available yet, show pending
    if (prerequisitesMet) {
      return 'pending';
    }

    // Otherwise, show disabled state
    return 'disabled';
  }, [userData]);
}